import { jsxs as k, jsx as e } from "react/jsx-runtime";
import { useState as N } from "react";
import K from "react-day-picker";
import { useTranslation as U } from "react-i18next";
import q from "next/image";
import w from "date-fns/addDays";
import C from "date-fns/differenceInCalendarDays";
import u from "@mui/material/Box";
import J from "@mui/material/InputAdornment";
import Q from "@mui/material/Popover";
import V from "@mui/material/TextField";
import P from "@mui/material/Typography";
import { makeStyles as X } from "tss-react/mui";
import { GREGORIAN_MONTHS as x } from "@lumirental/lumi-web-shared/lib/constants/date/GREGORIAN_MONTHS";
import Y from "@lumirental/lumi-web-shared/lib/constants/lang/DIR";
import { useLanguageContext as Z } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import ee from "@lumirental/lumi-web-shared/lib/utils/date/getArabicShortDayNameOfWeek";
import _ from "@lumirental/lumi-web-shared/lib/utils/date/getKSADate";
import te from "@lumirental/lumi-web-shared/lib/utils/date/getNextDay";
import { useBusRentalContext as ae } from "../../BusRental.context.js";
import re from "./DatePicker.style.js";
const A = X()(re);
function oe({
  isArabic: n,
  onPreviousClick: p,
  onNextClick: m,
  className: c
}) {
  const { classes: l } = A(), r = n ? `${c} ${Y.RTL}` : c;
  return /* @__PURE__ */ k("div", { className: r, children: [
    /* @__PURE__ */ e("button", { onClick: () => p(), className: l.navBtn, children: /* @__PURE__ */ e("img", { src: "/images/svg/arrow-prev-marble.svg", alt: "Arrow Previous" }) }),
    /* @__PURE__ */ e("button", { onClick: () => m(), className: l.navBtn, children: /* @__PURE__ */ e("img", { src: "/images/svg/arrow-next-marble.svg", alt: "Arrow Next" }) })
  ] });
}
function se({
  weekday: n,
  className: p,
  localeUtils: m,
  locale: c,
  isArabic: l
}) {
  const r = m.formatWeekdayLong(n, c), a = r.slice(0, 1), o = r.slice(0, 2), f = l ? ee(o) : a;
  return /* @__PURE__ */ e("div", { className: p, title: r, children: f });
}
const ne = ({ id: n, value: p }) => {
  const [m, c] = N(null), [l, r] = N(""), { classes: a } = A(), { t: o } = U(), { isArabic: f } = Z(), { pickupDate: i, setPickUpDate: I, dropoffDate: h, setDropOffDate: g } = ae(), O = `searchSelect${n}`, E = !!m, t = n === "pickupDate", W = o(t ? "starts_from" : "to_label"), S = t ? "date-pickup-active" : "", $ = f ? x.AR : x.EN, B = t ? i : [i, { from: i, to: h }], R = { start: i, end: h }, T = t ? _(/* @__PURE__ */ new Date()) : i, L = t ? w(_(/* @__PURE__ */ new Date()), 90) : w(i, 365), F = t ? i : h, M = [
    {
      before: T,
      after: L
    }
  ], j = `${a.paper}`, z = (s) => {
    r(""), c(s.currentTarget);
  }, v = () => {
    c(null);
  }, G = (s, { disabled: H }) => {
    let d = "";
    if (H) {
      const y = _(/* @__PURE__ */ new Date()), D = C(s, y), b = C(
        s,
        i
      );
      D < 0 ? d = o("please_select_a_day_in_the_future") : t && D === 0 ? d = o("no_time_slots_available") : !t && b >= 365 ? d = o("maximum_rental_duration_allowed_is_1_year") : !t && b < 0 ? d = o("please_select_a_day_in_the_future") : t && D >= 90 && (d = o("please_select_a_date_within_90_days_from_today")), r(d);
    } else {
      if (t) {
        const y = te(s);
        I(s), g(y);
      } else
        g(s);
      v(), r("");
    }
  };
  return /* @__PURE__ */ k(u, { className: a.wrapper, children: [
    /* @__PURE__ */ e(P, { variant: "body", className: a.fieldLabel, children: W }),
    /* @__PURE__ */ e(
      V,
      {
        fullWidth: !0,
        value: p,
        id: n,
        onClick: z,
        InputProps: {
          readOnly: !0,
          className: a.inputField,
          endAdornment: /* @__PURE__ */ e(
            J,
            {
              position: "end",
              className: a.arrowAdornment,
              "aria-controls": "arrow-dropdown",
              "aria-haspopup": "true",
              children: /* @__PURE__ */ e(
                q,
                {
                  src: "/images/svg/expand-arrow-icon.svg",
                  alt: "Arrow Icon",
                  width: 16,
                  height: 16
                }
              )
            }
          )
        },
        "data-testid": O
      }
    ),
    /* @__PURE__ */ k(
      Q,
      {
        id: n,
        open: E,
        anchorEl: m,
        onClose: v,
        classes: {
          paper: j
        },
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        children: [
          /* @__PURE__ */ e(u, { className: `${S} ${a.datePickerWrapper}`, children: /* @__PURE__ */ e(u, { className: a.dayPickerWrapper, children: /* @__PURE__ */ e(
            K,
            {
              modifiers: R,
              selectedDays: B,
              onDayClick: G,
              months: $,
              month: F,
              weekdayElement: (s) => /* @__PURE__ */ e(se, { ...s, isArabic: f }),
              navbarElement: /* @__PURE__ */ e(oe, { isArabic: f }),
              disabledDays: M
            }
          ) }) }),
          l && /* @__PURE__ */ e(u, { className: a.snackbar, children: /* @__PURE__ */ e(P, { variant: "body1", children: l }) })
        ]
      }
    )
  ] });
}, Ie = ne;
export {
  Ie as default
};
